import { render, staticRenderFns } from "./TissueEngineering.vue?vue&type=template&id=0ae4b974&scoped=true&"
var script = {}
import style0 from "./TissueEngineering.vue?vue&type=style&index=0&id=0ae4b974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae4b974",
  null
  
)

export default component.exports